import styled from "styled-components";

import { Flex } from "../Grid";

const MobileNav = styled(Flex)`
  z-index: 5000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    #00212f 0%,
    #00212f 30%,
    #00212f 30%,
    #006e7a 100%
  );
`;

MobileNav.defaultProps = {};

export { MobileNav };
